import React, {Component} from 'react';
import SearchWidget from "./components/SearchWidget/SearchWidget";
import styles from "./App.module.scss";
import {connect} from "react-redux";
import * as commonStateActions from "./services/common/actions";
import {setCacheValues} from "./services/flightCourse/actions";
import PropTypes from "prop-types";
import {animateScroll as scroll} from "react-scroll";

class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isFocused: false,
            originalScroll: window.pageYOffset
        };

        this.containerRef = React.createRef();
    }

    componentDidMount() {
        this.props.loadCommonInfo();
        this.props.setCacheValues();
    }

    focusLocalHandler = () => {
        this.setState({isFocused: true});
        const opts = this.containerRef.current.getBoundingClientRect();
        if (opts.top > 200) {
            scroll.scrollTo(360);
        }
    };

    blurLocalHandler = () => {
        this.setState({isFocused: false});
        //scroll.scrollTo(this.state.originalScroll);
    };

    render() {
        return (
            <div className={styles.appContainer}>
                <div className={this.state.isFocused ? 'search-widget-is-focused' : ''} role={'button'} tabIndex={0} ref={this.containerRef}
                    onFocus={this.focusLocalHandler}
                    onBlur={this.blurLocalHandler}>
                    <SearchWidget/>
                </div>
                <div className={[styles.knob, 'sw-knob-btn'].join(' ')}
                     style={!this.state.isFocused ? {backgroundColor: 'white'} : {}}
                     onClick={() => this.setState(prevState => ({isFocused: !prevState.isFocused}))}>
                    <i className={this.state.isFocused ? "fa fa-angle-up" : "fa fa-angle-down"} aria-hidden="true"/>
                </div>
            </div>
        );
    }
}

App.propTypes = {
    loadCommonInfo: PropTypes.func,
    setCacheValues: PropTypes.func,
};

App.defaultProps = {
    loadCommonInfo: () => null,
    setCacheValues: () => null,
};

export default connect(null, {...commonStateActions, setCacheValues})(App);
